import React from "react";

interface Answer {
  type: string;
  data: string[];
}

interface FAQs {
  question: string;
  answer: Answer[];
}

const FAQ = ({ faq }: { faq: FAQs[] }) => {
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const handleActiveIndex = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <div className="w-full flex flex-col items-start bg-white p-6 rounded-[12px]">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Frequently Asked Questions</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="w-full">
        {faq.map((faq, index) => (
          <div
            key={`item-${index}`}
            className="bg-[#F5F5F5] p-8 my-8 rounded-lg"
          >
            <button
              onClick={() => handleActiveIndex(index)}
              className="w-full flex justify-between items-center focus:outline-none"
              aria-expanded={activeIndex === index}
            >
              <h2 className="text-[17px] font-normal text-left">
                {faq.question}
              </h2>
              <div className="flex items-center">
                <div className="text-lg font-semibold">
                  {activeIndex === index ? (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12H19"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 5V19M5 12H19"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                activeIndex === index ? "max-h-96 mt-4" : "max-h-0"
              }`}
            >
              {activeIndex === index && (
                <div className="mt-4">
                  {faq.answer.map((ans, ansIndex) => (
                    <React.Fragment key={`answer-${index}-${ansIndex}`}>
                      {ans.type === "text" && (
                        <div className="text-[15px] text-gray-600">
                          {ans.data.map((text, textIndex) => (
                            <p
                              key={`text-${index}-${ansIndex}-${textIndex}`}
                              className="mb-2"
                            >
                              {text}
                            </p>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
